// import { initWasm, WalletCore } from '@trustwallet/wallet-core';
import * as libCrypto from '@ownerone/lib-crypto';

// import { PrivateKey, PublicKey } from './types';
// import { hexToBuffer, uint8ToHex } from './utils';

// const DEFAULT_PASSPHRASE = '';
export const generateMnemonic = async () => {
  const mnemonic = await libCrypto.generateMnemonic();

  return mnemonic;
};

// export const mnemonicToKeyPair = async (mnemonic: string) => libCrypto.ecies.mnemonicToKeyPair(mnemonic)

// export const derivePublicKey = async (
//   privateKey: PrivateKey,
// ): Promise<PublicKey> => {
//   console.log(privateKey);
//   throw Error('Not implemented');
//   // const twCore = await initTwCoreInstance();
//   // const bytes = hexToBuffer(privateKey);
//   // const pk = twCore.PrivateKey.createWithData(bytes);
//   // const publicKey = pk.getPublicKeySecp256k1(false);

//   // return uint8ToHex(publicKey.data());
// };
